module.exports = {
    tag: 'fortress',
    quality: 0.4,
    toughness: +4,
    armorClass: +10,
    speed: -1,
};